<template>
	<div id="app">
		<b-container>
			<b-row>
				<b-col xl="8" offset-xl="2">
					<b-img
						center
						id="logo-main"
            alt="South Dakota Mines Logo"
						:src="require('./assets/mines-logo.png')"
					/>
					<VueForm />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import VueForm from "./components/VueForm";

export default {
	name: "App",
	components: {
		VueForm
	}
};
</script>

<style>
#app {
	/*font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;*/
	margin: 50px 10px;
	color: #2c3e50;
}

#logo-cont {
	text-align: center;
}

#logo-main {
	height: 12em;
	margin-bottom: 1em;
}

.sdMines {
	color: #946e2b;
	font-family: Rockwell, "pt_sans_regular", Arial, sans-serif;
	font-size: 1.3em;
	margin-bottom: 0;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue